import React from "react";
import styled from "@emotion/styled";

const LoaderContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
`;

const SpinnerContainer = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Spinner = styled.img`
  width: 40px;
`;

const SmallSpinner = () => (
  <LoaderContainer className="spinner-rotate">
    <SpinnerContainer>
      <Spinner
        src={"https://cdn.cardcash.com/website/ui/elements/spinner-dark.png"}
        alt=""
      />
    </SpinnerContainer>
  </LoaderContainer>
);

export default SmallSpinner;
